import { AGENT_SUCCESS_TOUCH_STAGES } from 'manager/common/src/constants'
import { createSelector } from 'reselect'
import _ from 'lodash'

export const selectAuth = state => state.auth

export const selectAuthUser = createSelector(selectAuth, auth => (auth && auth.user) || {})

export const selectFeatureFlags = createSelector(selectAuthUser, user => user.feature_flags || {})

export const selectFeatures = createSelector(selectAuthUser, user => user.features || {})

export const selectFeaturesBootstrap = createSelector(selectFeatures, features => features.bootstrap || {})

export const selectAgentSuccess = createSelector(selectAuthUser, user => user.agent_success || {})

export const selectAgentTrainingCenter = createSelector(selectAgentSuccess, agent_success => agent_success.training_center || [])

export const selectAgentTrainingCenterTopics = createSelector(selectAgentTrainingCenter, trainingCenter => trainingCenter.map(tcTopic => _.pick(tcTopic, ['title', 'slug', 'summary'])))

export const selectSlugFromProps = (state, props) => {
  const { params = {} } = props
  return params.slug
}

export const selectAgentTrainingCenterTopic = createSelector(selectAgentTrainingCenter, selectSlugFromProps, (trainingCenterContent, slug) => {
  return _.find(trainingCenterContent, { slug }) || {}
})

export const selectAgentSuccessPhoneNumbers = createSelector(selectAgentSuccess, agent_success => agent_success.phone_numbers || {})

const selectStageFromProps = (state, props) => props.stage

export const selectAgentSuccessPhoneNumber = createSelector(
  selectAgentSuccessPhoneNumbers,
  selectStageFromProps,
  (phone_numbers, stage) => {
    switch (stage) {
      case AGENT_SUCCESS_TOUCH_STAGES.FIRST_WEEK:
        return phone_numbers.stage_two
      case AGENT_SUCCESS_TOUCH_STAGES.AFTER_FIRST_WEEK:
        return phone_numbers.stage_two
      case AGENT_SUCCESS_TOUCH_STAGES.FIRST_REFERRAL:
        return phone_numbers.stage_three
      case AGENT_SUCCESS_TOUCH_STAGES.FIRST_CONTRACT:
        return phone_numbers.stage_four
      default:
        return ''
    }
  }
)

export const selectAgentSuccessPhoneNumberFormatted = createSelector(
  selectAgentSuccessPhoneNumbers,
  selectStageFromProps,
  (phone_numbers, stage) => {
    switch (stage) {
      case AGENT_SUCCESS_TOUCH_STAGES.FIRST_WEEK:
        return phone_numbers.stage_two_formatted
      case AGENT_SUCCESS_TOUCH_STAGES.AFTER_FIRST_WEEK:
        return phone_numbers.stage_two_formatted
      case AGENT_SUCCESS_TOUCH_STAGES.FIRST_REFERRAL:
        return phone_numbers.stage_three_formatted
      case AGENT_SUCCESS_TOUCH_STAGES.FIRST_CONTRACT:
        return phone_numbers.stage_four_formatted
      default:
        return ''
    }
  }
)

export const selectAuthFeatureFlagAgentInboxEnabledAt = createSelector(
  selectFeatureFlags,
  feature_flags => feature_flags['agent_inbox_enabled_at']
)

export const selectAgentVideoCallEnabled = createSelector(
  selectFeaturesBootstrap,
  featuresBootstrap => featuresBootstrap.agent_video_call
)
